// removed by extract-text-webpack-plugin
module.exports = {"referencesList":"jDfCc03gImvK6dnOOYeQF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/references/References.css
// module id = 389
// module chunks = 0